import { AllieLoadingConfig } from "./LogoLoading.types";

export const ALLIE_LOADING_EVENTS = {
  HIDE_LOADING: 'allie:loading:hide',
  SHOW_LOADING: 'allie:loading:show',
} as const;

export const DEFAULT_CONFIG: AllieLoadingConfig = {
  autoHide: true,
  autoHideTime: 1500,
  safetyTime: 15000,
};
